<template>
  <transition name="plate-fade">
    <div class="plate" v-if="plate">
      <v-checkbox
        v-model="finalExpenses.isSelected"
        :error="$v.finalExpenses.isSelected.$error"
        :label="`${lead.firstname}. If you passed away early I assume YOU need
        to take care of final expenses? `"
      />

      <v-checkbox
        v-model="finalExpenses.isAgree"
        :error="$v.finalExpenses.isAgree.$error"
        label="Ok, I understand we Need to take care of the final expenses.
        Are you thinking:"
      />

      <v-btn-toggle
        v-model="finalExpenses.target"
        @change="onNeedsDetailsChange"
        class="my-2"
        :class="{ 'toggle-error': $v.finalExpenses.target.$error }"
      >
        <v-btn value="Cremation">Cremation</v-btn>
        <v-btn value="Casket">Casket</v-btn>
      </v-btn-toggle>

      <v-checkbox
        :error="$v.finalExpenses.isAgreeWithAmount.$error"
        :label="`Got it, you need Life Insurance to take care of the
          ${finalExpenses.target} it's going to be between:`"
        v-model="finalExpenses.isAgreeWithAmount"
      />

      <div v-if="finalExpenses.amount">
        {{ finalExpenses.amount }}
      </div>

      <v-checkbox
        :error="$v.plate.isAgreeWithRelationship.$error"
        label="And who's going to the Beneficiary on this policy?"
        v-model="plate.isAgreeWithRelationship"
      />

      <v-btn-toggle
        v-model="currentBeneficiary.relationship"
        @change="onRelationshipChange"
        class="my-2"
        :class="{ 'toggle-error': $v.currentBeneficiary.relationship.$error }"
      >
        <v-btn value="child">Child</v-btn>
        <v-btn value="spouse">Spouse</v-btn>
        <v-btn value="other">Other</v-btn>
      </v-btn-toggle>

      <v-checkbox
        :error="$v.plate.isAgreeWithBeneficiary.$error"
        :label="`You need to make sure final expenses are paid
               for ${currentBeneficiary.relationship} so they can
               focus on you and your memory, what's their name?`"
        v-model="plate.isAgreeWithBeneficiary"
      />

      <v-text-field
        :error="$v.currentBeneficiary.name.$error"
        label="Beneficiary name"
        v-model="currentBeneficiary.name"
        class="input-short"
      />

      <v-checkbox
        :error="$v.plate.isAgreeWithTakeCare.$error"
        :label="`
                ${lead.firstname} we'll make sure
                ${currentBeneficiary.name} has
                ${finalExpenses.amount} to take care of
                ${finalExpenses.target}`"
        v-model="plate.isAgreeWithTakeCare"
      />

      <template v-if="currentBeneficiary.relationship">
        <template v-if="isSpouseChoice">
          <v-checkbox
            v-model="plate.isStatusConfirm"
            :error="$v.plate.isStatusConfirm.$error"
            :label="`Is ${currentBeneficiary.name}:`"
          />

          <v-btn-toggle
            :class="{ 'toggle-error': $v.currentBeneficiary.status.$error }"
            v-model="currentBeneficiary.status"
            class="my-2"
          >
            <v-btn value="working">Working</v-btn>
            <v-btn value="retired">Retired</v-btn>
            <v-btn value="disabled">Disabled</v-btn>
          </v-btn-toggle>
        </template>
        <template v-else>
          <v-checkbox
            v-model="plate.isLiveInSameState"
            :error="$v.plate.isLiveInSameState.$error"
            :label="`Does ${currentBeneficiary.name} Live in the same state as you?`"
          />

          <v-btn-toggle
            v-model="currentBeneficiary.liveInSameState"
            :class="{
              'toggle-error': $v.currentBeneficiary.liveInSameState.$error,
            }"
            class="my-2"
          >
            <v-btn :value="true">Yes</v-btn>
            <v-btn :value="false">No</v-btn>
          </v-btn-toggle>

          <v-checkbox
            v-model="plate.isGiveAnyGrandkids"
            :error="$v.plate.isGiveAnyGrandkids.$error"
            :label="`Excellent, so they ${
              currentBeneficiary.liveInSameState ? 'won\'t' : 'will'
            }  have to travel from out of town.
                  Did they give you any grankids?`"
          />

          <v-text-field
            type="number"
            label="Number of Grandchildren:"
            v-model="currentBeneficiary.grandchildrenAmount"
            class="input-short"
          />
        </template>
      </template>

      <v-checkbox
        v-model="plate.isAgreeWithBeneficiaryCare"
        :error="$v.plate.isAgreeWithBeneficiaryCare.$error"
        :label="
          isSpouseChoice
            ? `Excellent, we'll take care of ${currentBeneficiary.name}`
            : `You must be PROUD! We'll take good care of ${currentBeneficiary.name}`
        "
      />

      <PlateFooter
        :onBack="onBack"
        :onSubmit="onSubmit"
        :isLoading="isLoading"
        :errors="$v.$error"
      />
    </div>
  </transition>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps, ProtectionTypes } from '@/common/variables';
import { isChecked } from '@/common/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'DisabledAnalysisPlate',
  components: {
    PlateFooter,
  },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ needs: 'plates/needs' }),
    finalExpenses() {
      return this.needs[ProtectionTypes.finalExpenses];
    },
  },
  data() {
    return {
      plate: null,
      isLoading: false,
      isSpouseChoice: true,
      currentBeneficiary: {},
    };
  },
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.disabledAnalysis
    );
    this.plate = data;
    this.currentBeneficiary = { ...this.beneficiary };
    this.isSpouseChoice = this.beneficiary.relationship === 'spouse';
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.occupation);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setBeneficiary', this.currentBeneficiary);
      this.$store.commit('plates/setStep', PlatesSteps.disabledNeeds);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
    onNeedsDetailsChange(val) {
      return (this.finalExpenses.amount =
        val === 'Cremation' ? '3-5K' : '8-10K');
    },
    onRelationshipChange(val) {
      if (val === 'spouse') {
        this.currentBeneficiary.grandchildrenAmount = null;
        this.currentBeneficiary.liveInSameState = null;
        this.isSpouseChoice = true;
      } else {
        this.currentBeneficiary.status = null;
        this.isSpouseChoice = false;
      }
    },
  },

  validations: {
    finalExpenses: {
      isSelected: { checked: isChecked },
      isAgree: { checked: isChecked },
      target: { required },
      isAgreeWithAmount: { checked: isChecked },
    },

    currentBeneficiary: {
      name: { required },
      relationship: { required },
      status: {
        required: function (val) {
          return !(this.isSpouseChoice && !val);
        },
      },
      liveInSameState: {
        boolean: function (val) {
          if (!this.isSpouseChoice)  {
            return typeof val === 'boolean';
          }
          return true;
        },
      },
    },

    plate: {
      isStatusConfirm: {
        checked: function (val) {
          return !(this.isSpouseChoice && !val);
        },
      },

      isAgreeWithRelationship: { checked: isChecked },
      isAgreeWithTakeCare: { checked: isChecked },
      isAgreeWithBeneficiary: { checked: isChecked },
      isAgreeWithBeneficiaryCare: { checked: isChecked },
      isGiveAnyGrandkids: {
        checked: function (val) {
          return !(!this.isSpouseChoice && !val);
        },
      },
      isLiveInSameState: {
        checked: function (val) {
          return !(!this.isSpouseChoice && !val);
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.toggle-error button {
  color: #ff5252 !important;
  border-color: #ff5252 !important;
}

.input-short {
  max-width: 300px;
}
</style>